import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { ServicesPage } from './pages/services/services';
import { ServicesPageFull } from './pages/services/services.full';
import { ServicesCommon } from './pages/services/services.common';
import { DynamicHTMLModule } from '../dynamic-html/dynamic-html.module';

import { ServicesData }from'./providers/services-data';
//Export
export { ServicesPage } from './pages/services/services';
export { ServicesPageFull } from './pages/services/services.full';

@NgModule({
    imports: [
        IonicModule,
        DynamicHTMLModule
    ],
    declarations: [
        ServicesPage,
        ServicesPageFull
    ],
    exports: [
        ServicesPage,
        ServicesPageFull
    ],
    bootstrap: [],
    entryComponents: [
        ServicesPage,
        ServicesPageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, ServicesData, ServicesCommon]
})
export class ServicesModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: ServicesPage, fullComponent: ServicesPageFull,  name: 'Services Page', segment: 'services' }
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/services/services.module.ts